import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columns = [
  new ColumnExcel('Libellé', 'libelle', true, 255),
  new ColumnExcel('Libellé interne', 'libelleInterne', false, 255),
  new ColumnExcel('Marque', 'marqueId', true),
  new ColumnExcel('Tags', 'tags'),
  new ColumnExcel('Date début', 'dateDebut'),
  new ColumnExcel('Date fin', 'dateFin'),
  new ColumnExcel('NewsLetter', 'newsLetter'),
  new ColumnExcel('Visible par le réseau', 'visibleParLaMarque'),
  new ColumnExcel('Image', 'urlImage'),
];

export function templateConfig(data) {
  return new ExportExcel(
    'TemplateCampagne.xlsx',
    [
      new SheetExcel(
        'Campagnes',
        columns,
        data,
        { skipHeader: false },
      ),
    ],
  );
}

export function generatedTemplateCampagne() {
  const exemple = {
    libelle: 'Campagne de noël',
    marqueId: 'Maybelline',
    tags: '"Fête","Belle"',
    dateDebut: '01/05/2023',
    dateFin: '31/05/2023',
    newsLetter: 'Non',
    visibleParLaMarque: 'Oui',
    urlImage: 'https://extranet.bachup.fr/img_bache/101315c91fba3.jpg',
  };
  const config = templateConfig([exemple]);
  ExportToExcel(config);
}
